import * as THREE from 'three'

export default class UnitView
{
    constructor(_options)
    {
        this.unit = _options.unit
        this.enemy = _options.enemy ?? false
        this.factory = _options.factory
        this.container = this.factory.createSkeleton(this.unit.type, this.enemy)
        this.container.position.set(this.unit.x, this.unit.y, 0)
        this.lastPosition = new THREE.Vector2(this.unit.x, this.unit.y)
        this.phase = Math.random() * Math.PI * 2
        this.lastCarryKey = ''
        const healthBackMaterial = new THREE.SpriteMaterial({ color: '#160f20', depthTest: false, opacity: 0.8, transparent: true })
        const healthMaterial = new THREE.SpriteMaterial({ color: this.enemy ? '#ff6d79' : '#65ffa4', depthTest: false })
        this.healthBack = new THREE.Sprite(healthBackMaterial)
        this.healthFill = new THREE.Sprite(healthMaterial)
        this.healthBack.scale.set(0.9, 0.09, 1)
        this.healthFill.scale.set(0.86, 0.055, 1)
        this.healthBack.position.set(0, 0, 2.05)
        this.healthFill.position.set(0, 0, 2.06)
        this.healthBack.renderOrder = 8
        this.healthFill.renderOrder = 9
        this.container.add(this.healthBack, this.healthFill)
        this.syncHealth()
    }

    syncHealth()
    {
        const ratio = Math.max(0, this.unit.health / this.unit.maxHealth)
        this.healthFill.scale.x = 0.86 * ratio
        this.healthFill.position.x = -0.43 * (1 - ratio)
        this.healthBack.visible = ratio < 1 || this.enemy
        this.healthFill.visible = this.healthBack.visible
    }

    syncCarry()
    {
        const key = this.unit.carry ? `${this.unit.carry.resource}-${this.unit.carry.count}` : ''
        if(key === this.lastCarryKey)
            return
        this.lastCarryKey = key
        const anchor = this.container.userData.carry
        for(const child of [...anchor.children])
        {
            child.traverse((_child) =>
            {
                if(_child.isMesh)
                    _child.geometry.dispose()
            })
            anchor.remove(child)
        }
        if(!this.unit.carry)
            return
        for(let index = 0; index < this.unit.carry.count; index++)
        {
            const item = this.factory.createItem(this.unit.carry.resource, 0.65)
            item.position.set((index % 2 - 0.5) * 0.22, 0, Math.floor(index / 2) * 0.18)
            anchor.add(item)
        }
    }

    update(_delta, _elapsed)
    {
        this.container.position.x = this.unit.x
        this.container.position.y = this.unit.y
        this.container.rotation.z = this.unit.rotation ?? 0
        const moved = Math.hypot(this.unit.x - this.lastPosition.x, this.unit.y - this.lastPosition.y)
        this.phase += moved * 9 + _delta * 2
        const swing = Math.min(0.65, moved * 30) * Math.sin(this.phase)
        const parts = this.container.userData
        parts.legs[0].rotation.x = swing
        parts.legs[1].rotation.x = - swing
        parts.arms[0].rotation.x = - swing * 0.7
        parts.arms[1].rotation.x = swing * 0.7
        if(this.unit.workCooldown > 1.45 || this.unit.cooldown > 0.55)
            parts.arms[1].rotation.x = -1.2 + Math.sin(_elapsed * 0.02) * 0.45
        parts.body.position.z = Math.abs(Math.sin(this.phase)) * Math.min(0.05, moved)
        this.lastPosition.set(this.unit.x, this.unit.y)
        this.syncHealth()
        this.syncCarry()
    }
}
